import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';
import { setReduxStore, getReduxStore } from './globals';
import Contact from './pages/contact/contact';
import Main from './pages/main/main';
import Welcome from './pages/welcome/welcome';
import NewAccount from './pages/new_account/new_account';
import FindAccount from './pages/find_acct/find_acct';
import ShoppingList from './pages/shopping_list/shopping_list';
import RecipePage from './pages/recipe/recipe_page';
import registerServiceWorker from './registerServiceWorker';
import Footer from './components/footer';
import Header from './components/title_bar';
import './css/index.css';

function saveToLocalStorage(state) {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem ('state', serializedState);
  }
  catch (err) {
    console.log(err);
  }
}

const persistedState = loadFromLocalStorage();

function loadFromLocalStorage() {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) return undefined
    return JSON.parse(serializedState);
  }
  catch (err) {
    console.log(err);
    return undefined;
  }
}

const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);
const st = createStoreWithMiddleware(reducers, persistedState);
setReduxStore(st);

st.subscribe(() => saveToLocalStorage(st.getState()));

//axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
//axios.defaults.headers.get['Accepts'] = 'application/json'
//axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'

ReactDOM.render((
  <Provider store={getReduxStore()}>
  <BrowserRouter>
    <div>
      <Header />
      <Route exact path="/recipe" component={RecipePage} />
      <Route exact path="/shop_list" component={ShoppingList} />
      <Route exact path="/find_acct" component={FindAccount} />
      <Route exact path="/new_acct" component={NewAccount} />
      <Route exact path="/main" component={Main} />
      <Route exact path="/contact" component={Contact} />
      <Route exact path="/" component={Welcome} />
      <Footer />
     </div>
  </BrowserRouter>
  </Provider>
  ), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js